<template>
	<u-code v-if="unit.control_code == 'code'"></u-code>
	<u-link-area v-else-if="unit.control_code == 'link_area'"></u-link-area>
</template>

<script>
	import uCode from '@/submodule/decorate_manage/components/unit/pc/code.vue'
	import uLinkArea from '@/submodule/decorate_manage/components/unit/link_area.vue'
	
	export default {
		components: {
			uCode,
			uLinkArea
		},
		
		props: {
			unit: Object
		}
	}
</script>